import { useEffect, useState } from "react";
import { getInitialValues } from "../../formData";
import { FirstFormFields } from "../../../../utils/form";
import Tooltip from "../../../../components/Tooltip";
import FieldCard from "../../../../components/FieldCard";

interface Props {
  values: any;
  handleFormItem: any;
}

const sections = [
  {
    title: "Identificação",
    types: ["property", "historical"],
  },
  {
    title: "Dimensões",
    types: ["area", "perimetro"],
  },
  {
    title: "Localização",
    types: [
      "bairro",
      "cidade",
      "endereco",
      "regional",
      "localizacao_praca",
    ],
  },
  {
    title: "Visita",
    types: ["date", "horario", "desniveis", "inclinacao", "visit.goal"],
  },
];

export default function FirstStep(props: Props) {
  const { values, handleFormItem } = props;
  const [initialValues, setInitialValues] = useState<any[]>([]);

  useEffect(() => {
    async function getFormValues() {
      const firstFormData = await getInitialValues();
      setInitialValues(firstFormData as any);
    }

    getFormValues();
  }, []);

  const renderField = (item: any) => {
    if (item.type === "inclinacao" && (values as any).desniveis !== "Sim") {
      return null;
    }

    const tooltips = {
      "visit.goal": {
        tooltip:
          "Insira aqui as condições climáticas no dia e horário da coleta de dados ou demais informações relevantes observadas durante a visita. Condições do clima: céu claro, céu parcialmente encoberto, etc. Temperatura do local no horário da coleta de dados (segundo INMET)",
      },
      property: {
        tooltip:
          "Caso a praça sofra reformas e seja necessária avaliá-la novamente e comparar com a avaliação antes da reforma deverá manter o mesmo nome, bairro e cidade.",
      },
      regional: {
        tooltip:
          "Somente praças com este campo “Regional” serão comparadas a outras praças da mesma região no relatório.",
      },
    };

    const tooltipFound = tooltips[item.type as keyof typeof tooltips];

    return (
      <FieldCard key={item.type}>
        <div className="mb-2 flex items-center gap-1">
          <p className="font-bold text-gray">
            {item.name}
            {item.required && (
              <span className="text-red" aria-hidden="true">
                &nbsp;*
              </span>
            )}
          </p>
          {tooltipFound && <Tooltip tooltip={tooltipFound.tooltip} />}
        </div>

        <FirstFormFields
          item={item}
          values={values}
          handleFormItem={handleFormItem}
        />

        {item.description && (
          <p className="mt-2 text-sm leading-relaxed text-muted">
            {item.description}
          </p>
        )}
      </FieldCard>
    );
  };

  return (
    <>
      <div className="mx-auto mb-8 max-w-3xl rounded-2xl border border-border bg-white p-5 text-sm leading-relaxed text-muted shadow-sm">
        <p>
          O QualificaURB auxilia a perceber a qualidade das praças e as
          oportunidades de melhoria dos espaços públicos. Campos com{" "}
          <span className="font-bold text-red">*</span> são obrigatórios para
          avançar.
        </p>
      </div>

      <div className="flex flex-col gap-8">
        {sections.map((section) => {
          const items = section.types
            .map((type) => initialValues.find((item) => item.type === type))
            .filter(Boolean);
          if (items.length === 0) {
            return null;
          }
          return (
            <section key={section.title}>
              <h2 className="mb-3 text-lg font-bold text-gray">
                {section.title}
              </h2>
              <div className="flex flex-col gap-3">
                {items.map((item) => renderField(item))}
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
}
